import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { ShipmentExport } from '../components/ShipmentExport';
import { ShipmentMetricsReport } from '../components/ShipmentMetricsReport';

export class TransportationReportsScene extends React.Component {

    public render() {
        return <PageContent pageName={'awef'}>
            <PageBody>
                <div className="row">
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsTransportationShipmentExport
                    ]}>
                        <div className="col-md-4"><ShipmentExport /></div>
                    </HasPermission>
                    <HasPermission requiredPermissions={[
                        Permissions.ReportsTransportationShipmentMetric
                    ]}>
                        <div className="col-md-4"><ShipmentMetricsReport /></div>
                    </HasPermission>
                </div>
            </PageBody>
        </PageContent>;
    }
}
